import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const fileUrl = (path) => (path ? `${API}/files/${path}` : null);
export const pct = (v) => (v == null ? "—" : `${(v * 100).toFixed(1)}%`);
export const errMsg = (e) => e?.response?.data?.detail || e.message || "Something went wrong";

export const identifyFile = (file, trueLabel, rerank = true) => {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("rerank", rerank ? "true" : "false");
  if (trueLabel) fd.append("true_label", trueLabel);
  return axios.post(`${API}/identify`, fd).then((r) => r.data);
};
export const identifyUrl = (url, trueLabel, rerank = true) =>
  axios.post(`${API}/identify-url`, { url, true_label: trueLabel || null, rerank }).then((r) => r.data);
export const listIds = (params) => axios.get(`${API}/identifications`, { params }).then((r) => r.data);
export const getId = (id) => axios.get(`${API}/identifications/${id}`).then((r) => r.data);
export const setLabel = (id, true_label) => axios.patch(`${API}/identifications/${id}/label`, { true_label });
export const deleteId = (id) => axios.delete(`${API}/identifications/${id}`);
export const getMetrics = () => axios.get(`${API}/evaluation/metrics`).then((r) => r.data);
export const getReviewQueue = (status) => axios.get(`${API}/review/queue`, { params: { status } }).then((r) => r.data);
export const submitReview = (id, body) => axios.post(`${API}/review/${id}`, body).then((r) => r.data);
export const undoReview = (id) => axios.delete(`${API}/review/${id}`);
export const suggestSpecies = (q) => axios.get(`${API}/species/suggest`, { params: { q } }).then((r) => r.data);
export const lookupSpecies = (name, country, country_name) => axios.get(`${API}/species/lookup`, { params: { name, country: country || undefined, country_name: country_name || undefined } }).then((r) => r.data);
export const matchPhotos = (identification_id, photos) => axios.post(`${API}/species/photo-match`, { identification_id, photos }).then((r) => r.data);
export const compareSpecies = (a, b) => axios.post(`${API}/species/compare`, { a, b }).then((r) => r.data);

export const SAMPLES = [
  { url: "https://inaturalist-open-data.s3.amazonaws.com/photos/591585754/medium.jpg", label: "Biston betularia", caption: "Peppered moth" },
  { url: "https://inaturalist-open-data.s3.amazonaws.com/photos/134833889/medium.jpg", label: "Actias luna", caption: "Luna moth" },
  { url: "https://inaturalist-open-data.s3.amazonaws.com/photos/523983310/medium.jpg", label: "Tyria jacobaeae", caption: "Cinnabar moth" },
  { url: "https://inaturalist-open-data.s3.amazonaws.com/photos/36127/medium.jpg", label: "Automeris io", caption: "Io moth" },
  { url: "https://inaturalist-open-data.s3.amazonaws.com/photos/156474264/medium.jpg", label: "Hemaris thysbe", caption: "Hummingbird clearwing" },
  { url: "https://static.inaturalist.org/photos/205844873/medium.jpeg", label: "Hyalophora cecropia", caption: "Cecropia moth" },
  { url: "https://inaturalist-open-data.s3.amazonaws.com/photos/189904375/medium.jpg", label: "Emmelina monodactyla", caption: "Plume moth" },
];
